'use client'
import { createContext, useCallback, useEffect, useState } from 'react'
import type { FC, ReactNode } from 'react'

export enum MODALS {
  CONTACT = 'modal_contact',
  FILTERS = 'modal_filters',
  MENU = 'modal_menu',
  NEWSLETTER = 'modal_newsletter',
  SEARCH = 'modal_search',
  VIDEO = 'modal_video',
  ZOOM = 'modal_zoom',
  PDP_SPEC_PDF = 'modal_pdp_spec_pdf',
	USER_JOURNEY_STANDALONE = 'modal_user_journey_standalone',
	USER_JOURNEY_CASAMBI = 'modal_user_journey_casambi',
	USER_JOURNEY_DALI_DT8 = 'modal_user_journey_dali_dt8'
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface iDefaultModal { isActive: boolean, payload?: any }

// interface iModalCustomerPayload {
//   payload: {
//     formType?: 'single' | 'excel'
//     customer?: {
//       id: number
//       name: string
//       email: string
//       phone?: string
//       companyName?: string
//     }
//   }
// }

// interface iModalUploadFilePayload {
//   payload: {
//     formType: 'excel' | 'zip'
//   }
// }

type TypeModalException = object

// Utility to merge two Definitions: B object properties shadowing -> A object properties
type $Merge<TA, TB> = Omit<TA, keyof TB> & TB;
// Getting the Base+Extended type of an Modal
type TypeModalById<A extends MODALS> = A extends keyof TypeModalException ? $Merge<iDefaultModal, TypeModalException[A]> : iDefaultModal


type TypeModals = {
  [key in MODALS]?: TypeModalById<key>
}
type TypeModalsState = {
  modals: TypeModals,
  setModal: (modal: { [key: string]: iDefaultModal } | ((prev: TypeModals) => TypeModals)) => void,
  someModalIsActive: boolean
}

const initialModalsState: TypeModalsState = {
  modals: {},
  setModal: () => {},
  someModalIsActive: false
  //someModalIsActive: boolean at least one modal is Active ?
}

interface iModalsProviderProps {
  children: ReactNode
}

export const ModalsContext = createContext<TypeModalsState | null>(initialModalsState)

export const ModalsProvider:FC<iModalsProviderProps> = ({ children }) => {
  const [modals, setModals] = useState<TypeModals>({})
  const [someModalIsActive, setSomeModalIsActive] = useState(false)

  const setModal = useCallback((modal) => {
    setModals(prevModals => ({...prevModals, ...modal }))
    let someActive = false

    const modalEnumName = Object.keys(modal)[0]
    const modalObj = modal[modalEnumName]
    if (modalObj.isActive) someActive = true
    else {
      for (const [enumName, m] of Object.entries(modals)) {
        if (enumName !== modalEnumName && m.isActive) {
          someActive = true
          break
        }
      }
    }

    setSomeModalIsActive(someActive)
  }, [modals])

  useEffect(() => {
    const html = document.body.parentElement
    html.style.overflow = someModalIsActive ? 'hidden' : 'initial'
  }, [someModalIsActive])

  return (<ModalsContext.Provider value={{ modals, setModal, someModalIsActive }}>
    {children}
  </ModalsContext.Provider>)
}
